module.exports = __webpack_public_path__ + "static/bitrhday-03eb38518d5fefcd4c6dc43b7e5c2813.jpg";